import { GeneralService } from "../../services/GeneralService";
import {
  SET_ARTIST_EXPERIENCE_CATEGORY_LIST,
  SET_EXPERIENCE_TYPE_LIST,
  SET_LOADING,
  SET_LOCATION_LIST,
  SET_RECRUITER_EXPERIENCE_CATEGORY_LIST,
  SET_REPORT_TYPE_LIST,
} from "./types";

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
  type: SET_LOADING,
  payload: data,
});

/**
 * @author Vikrant.
 * @since 08-06-2024.
 * @description to set Location list
 */
export const setArtistExperienceCategoryList = (data) => ({
  type: SET_ARTIST_EXPERIENCE_CATEGORY_LIST,
  payload: data,
});
/**
 * @author Vikrant.
 * @since 08-06-2024.
 * @description to set Location list
 */
export const setRecruiterExperienceCategoryList = (data) => ({
  type: SET_RECRUITER_EXPERIENCE_CATEGORY_LIST,
  payload: data,
});
/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set Location list
 */
export const setLocationList = (data) => ({
  type: SET_LOCATION_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 06-06-2024.
 * @description to set experience list
 */
export const setExperienceTypeList = (data) => ({
  type: SET_EXPERIENCE_TYPE_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to get Location list
 */
export const getLocationList =
  (successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await GeneralService.getLocationList()
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setLocationList(res?.data?.[0] || []));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Location list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Vikrant.
 * @since 08-06-2024.
 * @description to get artist experience category list
 */
export const getArtistExperienceCategoryList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await GeneralService.getExperienceCategoryList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setArtistExperienceCategoryList(res?.data?.[0] || []));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Artist Experience category list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Vikrant.
 * @since 08-06-2024.
 * @description to get recruiter experience category list
 */
export const getRecruiterExperienceCategoryList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await GeneralService.getExperienceCategoryList(params)
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(
          setRecruiterExperienceCategoryList(res?.data?.[0] || [])
        );
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Recruiter Experience category list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set Report Types list
 */
export const setReportTypesList = (data) => ({
  type: SET_REPORT_TYPE_LIST,
  payload: data,
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to get Report Type list
 */
export const getReportTypeList =
  (successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await GeneralService.getReportTypeList()
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setReportTypesList(res?.data?.[0] || []));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Report Type list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 13-02-2024.
 * @description to report job.
 */
export const reportJob =
  (request, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await GeneralService.reportJob(request)
      .then(async (res) => {
        successCallback?.(res);
      })
      .catch(async (err) => {
        console.log("Report job Error: ", err);
        errorCallback?.(err);
      })
      .finally(async () => {
        await dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 13-02-2024.
 * @description to report Profile.
 */
export const reportProfile =
  (request, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await GeneralService.reportProfile(request)
      .then(async (res) => {
        successCallback?.(res);
      })
      .catch(async (err) => {
        console.log("Report job Error: ", err);
        errorCallback?.(err);
      })
      .finally(async () => {
        await dispatch(setLoading(false));
      });
  };

/**
 * @author Sarthak Sharma.
 * @since 06-06-2024.
 * @description to get experience type list
 */
export const getExperienceTypeList =
  (successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await GeneralService.getExperienceTypeList()
      .then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setExperienceTypeList(res?.data?.[0] || []));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("Experience type list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
